export default "__VITE_ASSET__e2d018ee__"